import {
  SHADOW_AP_PER_CARD,
  SHADOW_BASE_AP,
} from "@/shadow/constants";
import type { ShadowDefinition } from "@/shadow/types";
import type { HomeEconomy } from "@/home/economy";
import {
  STAT_IDS,
  type StatAllocation,
  type StatId,
} from "@/game/model/character-stats";

export function shadowApBudget(shadow: ShadowDefinition): number {
  const cards = Math.max(0, Math.floor(shadow.apCardsApplied ?? 0));
  return SHADOW_BASE_AP + cards * SHADOW_AP_PER_CARD;
}

export function shadowApSpent(allocation: StatAllocation): number {
  return STAT_IDS.reduce((sum, id) => sum + allocation[id], 0);
}

export function shadowApRemaining(shadow: ShadowDefinition): number {
  return Math.max(0, shadowApBudget(shadow) - shadowApSpent(shadow.statAllocation));
}

export function allocateShadowStatPoint(
  shadow: ShadowDefinition,
  statId: StatId,
): ShadowDefinition | null {
  if (shadowApRemaining(shadow) <= 0) return null;
  return {
    ...shadow,
    statAllocation: { ...shadow.statAllocation, [statId]: shadow.statAllocation[statId] + 1 },
  };
}

export type ApplyShadowApCardResult =
  | { ok: true; economy: HomeEconomy; shadow: ShadowDefinition }
  | { ok: false; reason: string };

export function applyShadowApCard(
  economy: HomeEconomy,
  shadow: ShadowDefinition,
): ApplyShadowApCardResult {
  if (economy.shadowApCards < 1) {
    return { ok: false, reason: "ไม่มีบัตร AP ร่างเงาในคลัง · ซื้อที่ร้าน Cash" };
  }
  return {
    ok: true,
    economy: {
      ...economy,
      shadowApCards: economy.shadowApCards - 1,
    },
    shadow: {
      ...shadow,
      apCardsApplied: Math.max(0, Math.floor(shadow.apCardsApplied ?? 0)) + 1,
    },
  };
}
